import ServicesData from '../routes/Settings/Billing/servicesMap.json';

export function renderServices(key) {
  const foundKey = Object.keys(ServicesData).find(
    k => k?.toLowerCase() === key?.toLowerCase(),
  );
  return foundKey ? ServicesData[foundKey] : '';
}
